import React from 'react';
import ReactCheckboxTree, { OnCheckNode, OnExpandNode } from 'react-checkbox-tree';

import { ICheckboxTreeTypes } from './CheckboxTree.types';

import { icons } from './constants';

import './CheckboxTree.scss';

const CheckboxTree = ({
	tree,
	checked,
	expanded,
	onCheck,
	onClick,
	onExpand,
}: ICheckboxTreeTypes) => {
	const onClickHandler = (node: OnCheckNode) => (onClick) && onClick(node);

	const onCheckHandler = (checked: Array<string>, node: OnCheckNode) => (onCheck) && onCheck(checked, node);

	const onExpandHandler = (expanded: Array<string>, node: OnExpandNode) => onExpand && onExpand(expanded, node);

	return (
		<div className='f5gCheckboxTree'>
			<ReactCheckboxTree
				checked={checked}
				expanded={expanded}
				icons={icons}
				nodes={tree}
				onCheck={onCheckHandler}
				onClick={onClickHandler}
				onExpand={onExpandHandler}
			/>
		</div>
	);
};

export default CheckboxTree;
